import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

let sceneEnterB: any = null,
    sceneLeaveB: any = null,
    sceneTextEnterB: any = null,
    sceneTextLeaveB: any = null;
export default function B() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);
    const video1Ref = useRef();
    const video2Ref = useRef();
    const [textEnter, setTextEnter] = useState(false);
    const [changeCount, setChangeCount] = useState(0);
    const SITE_JP = 'jp';

    // 自动切换两次后不再切换
    const handlePlayEnd = () => {
        if (locale !== SITE_JP) {
            if (active === 0) {
                if (changeCount < 2) {
                    setActive(1);
                    setChangeCount(changeCount + 1);
                    video2Ref.current.play();
                } else {
                    video1Ref.current.play();
                }
            }
            if (active === 1) {
                if (changeCount < 2) {
                    setActive(0);
                    setChangeCount(changeCount + 1);
                    video1Ref.current.play();
                } else {
                    video2Ref.current.play();
                }
            }
        }
    };

    const handleChangTab = (n: number) => {
        changeCount < 2 && setChangeCount(2);
        if (active === n) return;
        if (n === 0) {
            setActive(0);
            video1Ref.current.currentTime = 0;
            video1Ref.current.play();
        }
        if (n === 1) {
            setActive(1);
            video2Ref.current.currentTime = 0;
            video2Ref.current.play();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            const resizeAni = () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                if (sceneTextEnterB) {
                    AniContainer.removeScene(sceneTextEnterB);
                    sceneTextEnterB = null;
                }
                if (sceneTextLeaveB) {
                    AniContainer.removeScene(sceneTextLeaveB);
                    sceneTextLeaveB = null;
                }
                sceneTextEnterB = AniContainer.create({
                    triggerElement: '.dpu-detail-B .sticky-box',
                    triggerHook: 1,
                    offset: startH,
                    // duration: 200,
                    onEnter: () => setTextEnter(true),
                });
                const videos = document.querySelector('.dpu-detail-B .videos') as HTMLUListElement;
                if (videos) {
                    sceneEnterB = AniContainer.create({
                        triggerElement: '.dpu-detail-B .videos .video.active',
                        triggerHook: 1,
                        offset: videos?.offsetHeight / 2,
                        duration: window?.innerHeight - videos?.offsetHeight / 2,
                        onEnter: () => {
                            if (locale !== SITE_JP) {
                                if (active === 0) {
                                    video1Ref.current.play();
                                }
                                if (active === 1) {
                                    video2Ref.current.play();
                                }
                            }
                        },
                    });

                    sceneLeaveB = AniContainer.create({
                        triggerElement: '.dpu-detail-B .videos .video.active',
                        triggerHook: 1,
                        offset: 0,
                        duration: window?.innerHeight + videos?.offsetHeight,
                        onLeave: () => {
                            if (locale !== SITE_JP) {
                                if (active === 0) {
                                    video1Ref.current.pause();
                                    video1Ref.current.currentTime = 0;
                                }
                                if (active === 1) {
                                    video2Ref.current.pause();
                                    video2Ref.current.currentTime = 0;
                                }
                            }
                        },
                    });
                }
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                if (sceneTextEnterB) {
                    AniContainer.removeScene(sceneTextEnterB);
                    sceneTextEnterB = null;
                }
                if (sceneTextLeaveB) {
                    AniContainer.removeScene(sceneTextLeaveB);
                    sceneTextLeaveB = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-B dpu-detail-section ${css['dpu-detail-B']}`}>
            <div className="sticky-box">
                <div className={`info-text ${textEnter ? 'enter' : ''}`}>
                    {locale === SITE_JP && <p className="subtitle">{t('secB_subtitle')}</p>}
                    <h2 className="title">{t('secB_title')}</h2>
                    <p className="desc">
                        {t.rich('secB_desc', {
                            w: (text: any) => <span className="white-text">{text}</span>,
                            n: (text: any) => <span className="no-wrap">{text}</span>,
                            sup: (text: any) => <sup className="sup">{text}</sup>,
                        })}
                    </p>
                </div>
                {locale === SITE_JP && (
                    <div className="img-box">
                        <EFPicture
                            src={'/responsive/picture/delta-pro-ultra/launch/2_jp.jpg'}
                            srcPad={'/responsive/picture/delta-pro-ultra/launch/2_768_jp.jpg'}
                            srcMobile={'/responsive/picture/delta-pro-ultra/launch/2_768_jp.jpg'}
                            alt={t('secB_title')}
                        />
                    </div>
                )}
                {locale !== SITE_JP && (
                    <ul className="videos">
                        <li className={`video ${active === 0 ? 'active' : ''}`}>
                            <video
                                ref={video1Ref}
                                src={`/responsive/video/delta-pro-ultra/launch/${locale === SITE_JP ? '16_1_jp' : '2_1'}.mp4`}
                                loop={locale === SITE_JP}
                                autoPlay={locale === SITE_JP}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_1.jpg"
                                aria-label={t('secB_tab1')}
                                onEnded={handlePlayEnd}
                            />
                            {locale !== SITE_JP && (
                                <div className="float-msg">
                                    <svg className="light-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.93401 13.8007L10.2631 19.5668L10.8833 19.2087L0.62021 1.43259L0 1.79067L2.7367 6.53077L0.000196251 10.6528H3.76002L2.86483 20.5L6.93401 13.8007ZM7.73947 12.4747L3.57698 5.26502L7.07225 0L6.71417 8.41485H10.2054L7.73947 12.4747Z"
                                            fill="white"
                                        />
                                    </svg>
                                    <p className="icon-text">{t('secB_icon')}</p>
                                </div>
                            )}
                        </li>
                        <li className={`video ${active === 1 ? 'active' : ''}`}>
                            <video
                                ref={video2Ref}
                                src={'/responsive/video/delta-pro-ultra/launch/2_2.mp4'}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_2.jpg"
                                aria-label={t('secB_tab2')}
                                onEnded={handlePlayEnd}
                            />
                        </li>
                    </ul>
                )}
                {locale !== SITE_JP && (
                    <ul className="tabs">
                        <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => handleChangTab(0)}>
                            {t('secB_tab1')}
                        </li>

                        <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => handleChangTab(1)}>
                            {t('secB_tab2')}
                        </li>
                    </ul>
                )}
                {/* {locale === SITE_JP && <p className="tip">{t('secB_tip')}</p>} */}
            </div>
        </section>
    );
}
